import React, { useState ,useEffect} from 'react'; 
 import { formatDateToYYYY_MM_DD } from "../../Utils/DateUtils";
 import Dist_RO_Report from '../ROReceivedStatus/Dist_RO_Report'
const Dist_RO_Int = ({ heading }) => {
    
    const [renderContent, setRenderContent] = useState(null);
    //todays date 
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); 
        const day = String(today.getDate()).padStart(2, "0"); 
        return `${year}-${month}-${day}`;
      };
      getTodayDate();

      const [selectedDate, setSelectedDate] = useState(getTodayDate());
    
      useEffect(() => {
             const timer = setTimeout(() => {
                handleSubmit();
            }, 10);
             return () => clearTimeout(timer);
    }, [ 100]); 

      const handleChange = (event) => {
        setSelectedDate(event.target.value);   
      };
    
    // Handling form submission
    const handleSubmit = () => {
         const trans_date = document.getElementById('trans_date').value; 
 
        if ( trans_date === null  || trans_date===0 || trans_date ===''  ) {
            alert('Please select Date');          
        }    else {
            const formatted_date = formatDateToYYYY_MM_DD(trans_date);

            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <Dist_RO_Report  trans_date={formatted_date}   heading={heading} />
                );
            }, 0);
                }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="25%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                     <td  align="center">Date</td>
                                    <td  align="center"><input type="date"   name="trans_date" 
                                     id="trans_date" value = {selectedDate} onChange={handleChange}/> </td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                    <button onClick={handleSubmit} className="button button2" >
                                    Submit
                                    </button>
                                    <button className="button button2">
                                    Back
                                    </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                      <div id="detailsER">{renderContent}</div>
                </div>
            </div>
            <br /><br />
        </>
    );
};

export default Dist_RO_Int;
